<template>
  <v-card>
    <v-toolbar color="primary">
      <v-toolbar-title class="white--text">Nivel de interés</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon color="white" @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <div class="pa-4">
      <!-- <div class="d-flex align-center">
        <span class="text-h6 mr-4">Estudio: {{ estudio }}</span>
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          dense
          hide-details="auto"
          solo
          v-model="search"
        />
      </div> -->

      <v-list dense>
        <v-list-item-group v-model="nuevo">
          <v-divider />
          <template v-for="(nivel, index) in nivelesFiltrados">
            <v-list-item :key="nivel.idNivelInteres" :value="nivel">
              <v-list-item-title>{{ nivel.nombre }}</v-list-item-title>
            </v-list-item>
            <v-divider
              :key="`${index}-divider`"
            ></v-divider>
          </template>
        </v-list-item-group>
      </v-list>

      <template v-if="nuevo">
        <v-divider></v-divider>
        <div class="d-flex align-center">
          <v-card-title> Cambiar nivel de interes : </v-card-title>
          <b>{{ nuevo.nombre }}</b>
          <v-spacer></v-spacer>
          <v-btn @click.stop="cambiarNivel" color="primary" outlined
            >Aceptar</v-btn
          >
        </div>
      </template>
    </div>
    <ConfirmDialog ref="confirm" />
  </v-card>
</template>

<script>
export default {
  components: {
    StatusChip: () => import("@/components/StatusChip.vue"),
    ConfirmDialog: () => import("@/components/ConfirmDialog.vue"),
  },
  props: {
    estudio: String | Number,
    interno: Boolean,
  },
  data() {
    return {
      nuevo: null,
      niveles: [],
      search: "",
    };
  },
  computed: {
    nivelesFiltrados() {
      if (!this.search) return this.niveles;
      return this.niveles.filter((c) =>
        c.nombre.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  async mounted() {
    try {
      const { data } = await axios(
        `${process.env.VUE_APP_API_URL}/nivel_interes`
      );
      this.niveles = data;
    } catch (e) {
      console.log(e);
      this.$root.$emit("snack", "Ha ocurrido un error");
    }
  },
  methods: {
    async cambiarNivel() {
      if (
        !(await this.$refs.confirm.open(
          "Cambiar tipo",
          "¿Estás seguro de que quieres asignar estos estudios a " +
            this.nuevo.nombre +
            "?"
        ))
      )
        return;

      await axios({
        method: "POST",
        url: `${process.env.VUE_APP_API_URL}/estudios/cambiar_nivel_interes`,
        data: {
          idEstudio: this.estudio,
          idNivelInteres: this.nuevo.idNivelInteres,
        },
      })
        .then((res) => {
          this.$root.$emit("snack", "Se ha cambiado el nivel de interés con éxito");
          this.nuevo = null;
          this.$emit("close");
          this.$emit("reload");
        })
        .catch((err) => {
          console.error(err);
          this.$root.$emit("snack", "No se ha podido cambiar el nivel de interés");
        });
    },
  },
};
</script>

<style></style>
